// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommandPaletteController from "./command_palette_controller"
application.register("command-palette", CommandPaletteController)

import CodeEditorController from "./code_editor_controller"
application.register("code-editor", CodeEditorController)

import FleetMultiselectController from "./fleet_multiselect_controller"
application.register("fleet-multiselect", FleetMultiselectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PillTabsController from "./pill_tabs_controller"
application.register("pill-tabs", PillTabsController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import ServiceFilterController from "./service_filter_controller"
application.register("service-filter", ServiceFilterController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
